export default "__VITE_ASSET__Bbmv_D7w__"